import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'

export interface UpdateHeadingBody {
  items: {
    id: number | undefined
    name: string
    position: number
    practice_tests: { practice_test_id: number; position: number }[]
  }[]
}

export const updateHeading = async ({
  classId,
  payload,
  isPractice,
}: {
  classId: string
  payload: UpdateHeadingBody
  isPractice: boolean
}) => {
  const response = await axiosInstance.put(`/class/${classId}/headings`, {
    items: payload.items,
    is_practice: isPractice,
  })
  return response.data
}

export const useUpdateHeading = () => {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending } = useMutation({
    mutationFn: updateHeading,
    mutationKey: ['updateHeading'],
    onSuccess: (_data, variables) => {
      const { classId, payload } = variables
      // Invalidate every ['headings', classId, …] cache (callers differ by enabled/limit).
      queryClient.invalidateQueries({ queryKey: ['headings', classId] })
      for (const item of payload.items) {
        if (item.id != null) {
          queryClient.invalidateQueries({
            queryKey: ['testByHeading', String(item.id)],
          })
        }
      }
    },
  })
  return { updateHeadingAsync: mutateAsync, isUpdatingHeading: isPending }
}
